export const SPRING_TRANSITION = {
  type: 'spring',
  stiffness: 250,
  damping: 35,
}
